import styled, { css } from 'styled-components';
import { borderRadius } from '../_styles/borderRadius';
import { colors } from '../_styles/colors';
import { getShadow } from '../_styles/shadows';
export var popoverArrowSize = 6;
export var StyledPopoverContent = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledPopoverContent",
  componentId: "core-12_20_2__sc-1cd0ihn-0"
})(["background-color:", ";border-radius:", "px;color:", ";display:inline-block;max-width:250px;position:relative;", ""], colors.white, borderRadius.md, colors.gray15, function (_ref) {
  var $block = _ref.$block,
    $fluid = _ref.$fluid;
  if ($block || $fluid) {
    return css(["max-width:none;"]);
  }
});
export var StyledPopover = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPopover",
  componentId: "core-12_20_2__sc-1cd0ihn-1"
})(["display:inline-block;", " & + [data-overlay-arrow]{background:", ";}"], getShadow(3), colors.white);
//# sourceMappingURL=Popover.styles.js.map